module.exports = __webpack_public_path__ + "Server-Disabled.AzureCloudService.d68b04fee6785efecca410b256e6f095.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Disabled.AzureCloudService.png
// module id = 6410663432391537
// module chunks = 1